
/* global BrowserPrint */
import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { getPackingBoxOptions, darEntradaFinishedProduct } from '../../services/api'; // Funções de API
import ConfirmModal from './confirmx';
import FeedbackModal from './FeedbackModal';

// Função para enviar o ZPL para a impressora via BrowserPrint
function enviarZPLParaImpressora(zplCode) {
  BrowserPrint.getDefaultDevice("printer", function(printer) {
      if (printer) {
          printer.send(zplCode, function() {
              console.log("Etiqueta enviada para a impressora com sucesso.");
          }, function(error) {
              console.error("Erro ao enviar para a impressora:", error);
          });
      } else {
          console.error("Impressora não encontrada.");
      }
  });
}

const DarEntradaModal = ({ visible, onHide, productReference, productName, onConfirm }) => {
  const [numberOfBoxes, setNumberOfBoxes] = useState(0);
  const [quantityPerBox, setQuantityPerBox] = useState(0);
  const [boxType, setBoxType] = useState(null);
  const [obs, setObs] = useState('');
  const [boxTypeOptions, setBoxTypeOptions] = useState([]);

  // Estados para modais de confirmação e feedback
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [feedbackVisible, setFeedbackVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionComplete, setSubmissionComplete] = useState(false);
  const [submissionError, setSubmissionError] = useState(null);

  // Busca as opções de boxType via API quando a modal estiver visível
  useEffect(() => {
    if (visible) {
      getPackingBoxOptions()
        .then(response => {
          const options = response.data.map(item => ({
            label: item.reference,
            value: item.reference
          }));
          setBoxTypeOptions(options);
        })
        .catch(error => {
          console.error('Erro ao buscar opções de tipo de caixa:', error);
        });
    }
  }, [visible]);

  // Ao clicar em "Confirmar" exibe o modal de confirmação
  const onConfirmClick = () => {
    setConfirmVisible(true);
  };

  // Se o usuário confirmar, constrói o payload, chama a API e, em caso de sucesso, imprime a etiqueta
  const handleSubmit = async () => {
    // Constrói o payload usando o nome do produto
    const payload = {
      product_name: productName,
      number_of_boxes: numberOfBoxes,
      quantity_per_box: quantityPerBox,
      box_type: boxType,
      obs: obs
    };

    console.log("Iniciando submit com payload:", payload);

    setConfirmVisible(false);
    setFeedbackVisible(true);
    setIsSubmitting(true);
    setSubmissionComplete(false);
    setSubmissionError(null);

    try {
      console.log("Chamando API darEntradaFinishedProduct com payload:", payload);
      const response = await darEntradaFinishedProduct(productReference, payload);
      console.log("API chamada com sucesso.");
      setIsSubmitting(false);
      setSubmissionComplete(true);
      
        if (response.data.label) {
          const zplCode = response.data.label; // já é uma string
          enviarZPLParaImpressora(zplCode);
      } else {
          console.warn("Nenhuma etiqueta retornada pelo backend.");
      }
      
      // Após um curto delay, fecha o modal de feedback e reseta os campos
      setTimeout(() => {
        setFeedbackVisible(false);
        setNumberOfBoxes(0);
        setQuantityPerBox(0);
        setBoxType(null);
        setObs('');
        onHide(); // Fecha a modal principal
        console.log("Campos resetados e modais fechadas.");
      }, 1500);
    } catch (error) {
      console.error("Erro na chamada da API:", error);
      setIsSubmitting(false);
      setSubmissionError(error.message || 'Erro na submissão');
      setTimeout(() => {
        setFeedbackVisible(false);
        console.log("Modal de feedback fechada após erro.");
      }, 3000);
    }
  };

  const handleCancelConfirm = () => {
    setConfirmVisible(false);
  };

  const footer = (
    <div>
      <Button 
        label="Cancelar" 
        icon="pi pi-times" 
        onClick={() => {
          onHide();
          setNumberOfBoxes(0);
          setQuantityPerBox(0);
          setBoxType(null);
          setObs('');
        }} 
        className="p-button-text" 
      />
      <Button 
        label="Confirmar" 
        icon="pi pi-check" 
        onClick={onConfirmClick} 
        autoFocus 
      />
    </div>
  );

  return (
    <>
      <Dialog 
        header={`Está a dar entrada de ${productReference}`} 
        visible={visible} 
        style={{ width: '30vw' }} 
        footer={footer} 
        onHide={onHide}
      >
        {/* Exibe o nome do produto abaixo do header */}
        <div style={{ marginBottom: '1rem', fontWeight: 'bold' }}>
          Artigo: {productName}
        </div>
        <div 
          style={{ 
            display: 'grid', 
            gridTemplateColumns: '1fr 1fr', 
            gap: '1rem',
            justifyItems: 'center',
            alignItems: 'center'
          }}
        >
          <div className="p-field">
            <label htmlFor="numberOfBoxes">Número de Caixas</label>
            <InputNumber 
              id="numberOfBoxes" 
              value={numberOfBoxes} 
              onValueChange={(e) => setNumberOfBoxes(e.value)} 
              mode="decimal"
              showButtons
              buttonLayout="vertical"
              style={{ width: '4rem' }}
              decrementButtonClassName="p-button-secondary"
              incrementButtonClassName="p-button-secondary"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
            />
          </div>
          <div className="p-field">
            <label htmlFor="quantityPerBox">Quantidade por Caixa</label>
            <InputNumber 
              id="quantityPerBox" 
              value={quantityPerBox} 
              onValueChange={(e) => setQuantityPerBox(e.value)} 
              mode="decimal"
              showButtons
              buttonLayout="vertical"
              style={{ width: '4rem' }}
              decrementButtonClassName="p-button-secondary"
              incrementButtonClassName="p-button-secondary"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
            />
          </div>

          {/* Campo: Tipo de Caixa com opções obtidas via API */}
          <div className="p-field" style={{ gridColumn: '1 / span 2', width: '100%' }}>
            <label htmlFor="boxType">Tipo de Caixa</label>
            <Dropdown
              id="boxType"
              value={boxType}
              options={boxTypeOptions}
              onChange={(e) => setBoxType(e.value)}
              placeholder="Selecione o tipo de caixa"
              style={{ width: '100%' }}
            />
          </div>

          {/* Campo: Observações */}
          <div className="p-field" style={{ gridColumn: '1 / span 2', width: '100%' }}>
            <label htmlFor="obs">Observações</label>
            <InputTextarea
              id="obs"
              value={obs}
              onChange={(e) => setObs(e.target.value)}
              rows={3}
              style={{ width: '100%' }}
            />
          </div>
        </div>
      </Dialog>
      <ConfirmModal 
        visible={confirmVisible} 
        message={`Confirma a dar entrada de ${productReference}?`} 
        onConfirm={handleSubmit} 
        onCancel={handleCancelConfirm} 
      />
      <FeedbackModal 
        open={feedbackVisible} 
        isSubmitting={isSubmitting} 
        submissionComplete={submissionComplete} 
        error={submissionError} 
        onClose={() => setFeedbackVisible(false)} 
      />
    </>
  );
};

export default DarEntradaModal;
